import React, { useEffect, useState } from 'react';
import { Tab, Nav } from 'react-bootstrap';
import LeadFilter from "./LeadFilter";
import LeadTable from "./LeadTable";
import { useDispatch } from 'react-redux';
import { getLeadList } from '@src/store/slices/lead';
import FullPageLoader from '@src/common/FullPageLoader';
import { KEY_LEAD_ACTIVE_TAB_MAP } from '@src/config/constant';
import { getMasterConfig } from '../store/slices/common';
import { useLanguage } from "@src/context/LanguageContext";
import { useSearchParams } from 'react-router-dom';

const LeadList: React.FC = () => {

  const dispatch: any = useDispatch();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState<boolean>(false);
  const [paginationData, setPaginationData] = useState<any>({});
  const [leadList, setLeadList] = useState<any>([]);
  const [selectedFilters, setSelectedFilters] = useState<any>({});
  const [statusFilterList, setStatusFilterList] = useState<any>([]);
  const [reasonList, setReasonList] = useState<any>([]);
  const [activeTab, setActiveTab] = useState<any>('all_count');
  const [defaultactiveTab, setDefaultactiveTab] = useState<any>('first');
  const {translations} = useLanguage();
  const [typeList, setTypeList] = useState<any>([]);

  let searchKeywordParam: any = searchParams.get('searchKeyword');
  let filterType: any = searchParams.get('filterType');

  useEffect(() => {
    getMasterConfigApi();

    let updatedSelctedFilters: any = {...selectedFilters,
      sortBy:{lead_created_at: 'desc'},
    };

    if (searchKeywordParam && searchKeywordParam) {
        updatedSelctedFilters['searchKeyword'] = searchKeywordParam;
    }
    if (filterType) {
         setActiveTab(filterType);
         const key = getKeyFromValue(filterType);
         setDefaultactiveTab(key);
         updatedSelctedFilters['activeTab'] = filterType;

    }
    if (!searchKeywordParam && !filterType) {
        updatedSelctedFilters = {};
    } else {
        setSelectedFilters((prev: any) => { return { ...prev, ...updatedSelctedFilters }; });
    }
    
    getLeadListing(updatedSelctedFilters);
   // getLeadListing({});
    // eslint-disable-next-line 
  }, [searchKeywordParam, translations])

  const getKeyFromValue = (value: any) =>{
    for (let key in KEY_LEAD_ACTIVE_TAB_MAP) {
      if (KEY_LEAD_ACTIVE_TAB_MAP[key] === value) {
        return key.toString();
      }
    }
    return null; // Return null if no match is found
  }

  const getMasterConfigApi = () => {
    setLoading(true);
    dispatch(getMasterConfig()).then((res: any) => {
      if (res && res.status === 200) {
        if (res.data) {
          setStatusFilterList(res.data['lead_status']);
          setTypeList(res.data['type_list']);
          if(res.data['reason_master']){
            setReasonList(res.data['reason_master']);
          }
        }
      }
    }).catch((err: Error) => {
      setLoading(false);
    })
  }

  //GET RECONCILIATION LIST API
  const getLeadListing = (params: any) => {
      let filters = {
          page_number: params?.page_number ?? 1,
          isPaginationApply: true,
          activeTab,
          ...params,
      }
      setLoading(true)
      dispatch(getLeadList(filters)).then((res: any) => {
          setLoading(false)
          if (res && res.status === 200) {
              setPaginationData({ ...res.pagination })
              setLeadList([...res.data])
          }
      }).catch((err: Error) => {
          setLoading(false)
      })
  }

  const activeTabHandler = (tab: any) => {
    if (!tab) return;
    const activeTab = KEY_LEAD_ACTIVE_TAB_MAP[tab];
    if (activeTab) {
      setActiveTab(activeTab);
      setDefaultactiveTab(tab);
      selectedFilters.activeTab = activeTab;
      getLeadListing({ page_number: 1, activeTab, ...selectedFilters });
    }
  }
  return (
    <>
      <FullPageLoader show={loading} />
      <div className="lead-list-outer container-fluid main-outer">
        <div>
          <div className="top-heading top-heading-btn">
            <h1>{translations.Insurance?.['APPLICATION_DETAILS'] || translations.commonMsg?.loading}</h1>
            {/* <button className="btn-line btn-export">
              <i className="ic-save_alt m-sm-r"></i>
              Download Data
            </button> */}
          </div>

          <div className="loan-filter-bg">
            <div className="top-filter-bg">
              <LeadFilter submitHandler={(filterParams: any) => { getLeadListing(filterParams) }} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} statusFilterList={statusFilterList} typeList={typeList}/>
            </div>
          </div>

          <div className="lead-list-table-outer">
            <Tab.Container id="lead-tabs" activeKey={defaultactiveTab} defaultActiveKey='first'>
              <Nav variant="pills" className="flex-column nav nav-pills" onSelect={(k) => activeTabHandler(k)}>
                <div className="tab-list">
                  <Nav.Item>
                        <Nav.Link eventKey="first">
                            {translations.Insurance?.['ALL'] || translations.commonMsg?.loading} <span>({(paginationData && paginationData['all_count']) || 0})</span></Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="second">
                            {translations.Insurance?.['IN_PROGESS'] || translations.commonMsg?.loading}<span>({(paginationData && paginationData['in_process']) || 0})</span></Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                        <Nav.Link eventKey="third">
                           {translations.Dashboard?.['POLICY_ISSUED'] || translations.commonMsg?.loading}  <span>({(paginationData && paginationData['policy_issued']) || 0})</span></Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="fourth">
                           {translations.Insurance?.['REJECTED'] || translations.commonMsg?.loading}  <span>({(paginationData && paginationData['rejected']) || 0})</span></Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="fifth">
                           {translations.Insurance?.['ACTION_NEEDED'] || translations.commonMsg?.loading} <span>({(paginationData && paginationData['action_needed_by_oto']) || 0})</span></Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="sixth">
                           {translations.Insurance?.['RE_SUBMITTED'] || translations.commonMsg?.loading} <span>({(paginationData && paginationData['re_submitted_for_review']) || 0})</span></Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="seventh">
                            {translations.Insurance?.['LOST_LEADS'] || translations.commonMsg?.loading}  <span>({(paginationData && paginationData['lost']) || 0})</span></Nav.Link>
                    </Nav.Item>
                </div>
              </Nav>

              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <LeadTable leadList = {leadList} paginationData={paginationData} getLeadListing={getLeadListing} selectedFilters={selectedFilters} statusFilterList={statusFilterList} reasonList={reasonList} />
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <LeadTable leadList = {leadList} paginationData={paginationData} getLeadListing={getLeadListing} selectedFilters={selectedFilters} statusFilterList={statusFilterList} reasonList={reasonList}/>
                </Tab.Pane>
                <Tab.Pane eventKey="third">
                  <LeadTable leadList = {leadList} paginationData={paginationData} getLeadListing={getLeadListing} selectedFilters={selectedFilters} statusFilterList={statusFilterList} reasonList={reasonList}/>
                </Tab.Pane>
                <Tab.Pane eventKey="fourth">
                   <LeadTable leadList = {leadList} paginationData={paginationData} getLeadListing={getLeadListing} selectedFilters={selectedFilters} statusFilterList={statusFilterList} reasonList={reasonList}/>
                </Tab.Pane>
                 <Tab.Pane eventKey="fifth">
                   <LeadTable leadList = {leadList} paginationData={paginationData} getLeadListing={getLeadListing} selectedFilters={selectedFilters} statusFilterList={statusFilterList} reasonList={reasonList}/>
                </Tab.Pane>
                 <Tab.Pane eventKey="sixth">
                   <LeadTable leadList = {leadList} paginationData={paginationData} getLeadListing={getLeadListing} selectedFilters={selectedFilters} statusFilterList={statusFilterList} reasonList={reasonList}/>
                </Tab.Pane>
                 <Tab.Pane eventKey="seventh">
                   <LeadTable leadList = {leadList} paginationData={paginationData} getLeadListing={getLeadListing} selectedFilters={selectedFilters} statusFilterList={statusFilterList} reasonList={reasonList}/>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        </div>
      </div>
    </>

  );
};

export default LeadList;
